import { render, staticRenderFns } from "./WinMenu.vue?vue&type=template&id=15634526&scoped=true"
import script from "./WinMenu.vue?vue&type=script&lang=js"
export * from "./WinMenu.vue?vue&type=script&lang=js"
import style0 from "./WinMenu.vue?vue&type=style&index=0&id=15634526&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15634526",
  null
  
)

export default component.exports